//RNM_PC_02-04 - Vishwa S
import React, { Component } from 'react';
import swal from 'sweetalert';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import * as MenuAction from '../actions/MenuAction';
import * as ReleaseNotesMaintenanceAction from '../actions/ReleaseNotesMaintenanceAction';
import ReleaseNotesMaintenanceStore from '../stores/ReleaseNoteMaintenanceStore';
import { withTranslation, Trans } from 'react-i18next';
import * as AddVersionComponent from '../components/AddVersionComponent';
let deleteVersionNumber = "";

//RNM_PC_01 - Vishwa S
class ReleaseNotesMaintenanceComponent extends Component {

    //RNM_PC_05-06 - Vishwa S
    constructor(props) {
        super(props);
        //this.pageLoadResponse = this.pageLoadResponse.bind(this);
        this.bindAllVersionDetails = this.bindAllVersionDetails.bind(this);
        this.pageLoadResponse = this.pageLoadResponse.bind(this);
        this.webTabHandleClick = this.webTabHandleClick.bind(this);
        this.mobTabHandleClick = this.mobTabHandleClick.bind(this);

        this.state = {
            pageCount: 0, pageNo: 1, masterDataArr: [], webArr: [], mobArr: [], source: this.props.location.state && this.props.location.state.source ? this.props.location.state.source : "WEB", bindArr: [], viewVersionNumber: "", viewFeatureArr: [], viewBugArr: [], searchValue: "", itemPerPage: 10
        }

    }
    //RNM_PC_07-08, RNM_PC_32-33 - Vishwa S
    componentDidMount() {
        this.pageLoad()
        ReleaseNotesMaintenanceStore.on('ReleaseNotesPageLoadResponse', this.pageLoadResponse);
        ReleaseNotesMaintenanceStore.on('deleteSuccess', this.BuildDeleteMessage);

    }
    //RNM_PC_09, RNM_PC_34 - Vishwa S
    componentWillUnmount() {
        ReleaseNotesMaintenanceStore.removeListener('ReleaseNotesPageLoadResponse', this.pageLoadResponse);
        ReleaseNotesMaintenanceStore.removeListener('deleteSuccess', this.BuildDeleteMessage);
    }

    //RNM_PC_55-65 - Vishwa S
    sortData = (sortBy) => {
       
        let sortedData = [...this.state.bindArr];

        if (sortBy === "ASC") {

            sortedData.sort(function (a, b) {
                return a.VERSION_NO.localeCompare(b.VERSION_NO);
            });
        } else if (sortBy === "DESC") {

            sortedData.sort(function (a, b) {
                return b.VERSION_NO.localeCompare(a.VERSION_NO);
            });
        }

        this.setState({ bindArr: sortedData });
    }

    //RNM_PC_14-16 - Vishwa S
    pageLoad = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ReleaseNotesMaintenanceAction.PageloadAction();
        if (this.state.source == "MOB") {
            this.mobTabHandleClick();
        }
    }

    //RNM_PC_35-50,54 - Vishwa S
    pageLoadResponse = () => {
        let masterDataArr = JSON.parse(ReleaseNotesMaintenanceStore.pageLoadResponse);
        const webFilteredData = masterDataArr
            .filter(item => item.ACTIVE_FLAG === 'Y' && item.SOURCE === 'WEB')
            .reduce((result, item) => {
                const existingItem = result.find(r => r.VERSION_NO === item.VERSION_NO);
                if (existingItem) {
                    if (item.TASK_TYPE === 'E') {
                        existingItem.Features++;
                    } else if (item.TASK_TYPE === 'B') {
                        existingItem.Bugs++;
                    }
                } else {
                    const newItem = {
                        VERSION_NO: item.VERSION_NO,
                        Features: item.TASK_TYPE === 'E' ? 1 : 0,
                        Bugs: item.TASK_TYPE === 'B' ? 1 : 0,
                    };
                    result.push(newItem);
                }
                return result;
            }, []);

        const webFilteredSortData = webFilteredData.sort(function (a, b) {
            return b.VERSION_NO.localeCompare(a.VERSION_NO);
        });

        const mobFilteredData = masterDataArr
            .filter(item => item.ACTIVE_FLAG === 'Y' && item.SOURCE === 'MOB')
            .reduce((result, item) => {
                const existingItem = result.find(r => r.VERSION_NO === item.VERSION_NO);
                if (existingItem) {
                    if (item.TASK_TYPE === 'E') {
                        existingItem.Features++;
                    } else if (item.TASK_TYPE === 'B') {
                        existingItem.Bugs++;
                    }
                } else {
                    const newItem = {
                        VERSION_NO: item.VERSION_NO,
                        Features: item.TASK_TYPE === 'E' ? 1 : 0,
                        Bugs: item.TASK_TYPE === 'B' ? 1 : 0,
                    };
                    result.push(newItem);
                }
                return result;
            }, []);
        const mobFilteredSortData = mobFilteredData.sort(function (a, b) {
            return b.VERSION_NO.localeCompare(a.VERSION_NO);
        });
        let count = 0;
        if (this.state.source === "WEB") {
            count = Math.ceil(webFilteredSortData.length / 10);
        }
        else if (this.state.source === "MOB") {
            count = Math.ceil(mobFilteredSortData.length / 10);
        }
        this.setState({ masterDataArr: masterDataArr, webArr: webFilteredSortData, mobArr: mobFilteredSortData, pageCount: count, bindArr: this.state.source == "WEB" ? webFilteredSortData : mobFilteredSortData, pageNo: 1 })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    //RNM_PC_45-49 - Vishwa S
    mobTabHandleClick = (e) => {
        let count = Math.ceil(this.state.mobArr.length / 10);
        this.setState({ bindArr: this.state.mobArr, source: "MOB", pageCount: count, searchValue: "", pageNo: 1 })
    }

    //RNM_PC_50-54 - Vishwa S
    webTabHandleClick = (e) => {
        let count = Math.ceil(this.state.webArr.length / 10);
        this.setState({ bindArr: this.state.webArr, source: "WEB", pageCount: count, searchValue: "", pageNo: 1 })
    }

    //RNM_PC_104-106 - Vishwa S
    handlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.setState({ pageNo: pageNo });
    }

    //RNM_PC_70-73 - Vishwa S
    createNewVersion = () => {
        
        const webVersions = this.state.webArr.map(item => item.VERSION_NO);
        const mobVersions = this.state.mobArr.map(item => item.VERSION_NO);
        this.props.history.push({
            pathname: "/addversioncomponent",
            state: { webVersions: webVersions, mobVersions: mobVersions, submitType: "Insert", source: this.state.source, sendEnhancementArr: [], sendBugArr: [], mobileVersion: "", webVersion: "" }
        });
    }

    closeViewPopUp = (e) => {
        $('#ViewVersionDetailsPopUp').modal('hide');
    };

    viewVersion = (version) => {
        let viewFeatureArr = [];
        let viewBugArr = [];
        if (this.state.source === "WEB") {
            viewFeatureArr = this.state.masterDataArr.filter(item => item.VERSION_NO === version && item.TASK_TYPE === "E" && item.SOURCE === "WEB" && item.ACTIVE_FLAG === "Y").sort((a, b) => a.TASK_NO - b.TASK_NO);
            viewBugArr = this.state.masterDataArr.filter(item => item.VERSION_NO === version && item.TASK_TYPE === "B" && item.SOURCE === "WEB" && item.ACTIVE_FLAG === "Y").sort((a, b) => a.TASK_NO - b.TASK_NO);
        }
        else if (this.state.source === "MOB") {
            viewFeatureArr = this.state.masterDataArr.filter(item => item.VERSION_NO === version && item.TASK_TYPE === "E" && item.SOURCE === "MOB" && item.ACTIVE_FLAG === "Y").sort((a, b) => a.TASK_NO - b.TASK_NO);
            viewBugArr = this.state.masterDataArr.filter(item => item.VERSION_NO === version && item.TASK_TYPE === "B" && item.SOURCE === "MOB" && item.ACTIVE_FLAG === "Y").sort((a, b) => a.TASK_NO - b.TASK_NO);
        }
        this.setState({ viewFeatureArr: viewFeatureArr, viewBugArr: viewBugArr, viewVersionNumber: version });
        $('#ViewVersionDetailsPopUp').modal('show');
    }

    bindFeatures = () => {
        let viewFeatureArr = this.state.viewFeatureArr;
        return viewFeatureArr.map((value, index) => {
            return (<li className="view_list_style">{value.TASK_TITLE}</li>)
        });
    }

    bindBugs = () => {
        let viewBugArr = this.state.viewBugArr;
        return viewBugArr.map((value, index) => {
            return (<li className="view_list_style">{value.TASK_TITLE}</li>)
        });
    }

    ClearSearch = () => {
        this.setState({ searchValue: "" })
        this.setDefault()
    }

    bindAllVersionDetails = () => {
        
        let bindArr = this.state.bindArr
        return bindArr.map((val, index) => {
            //console.error("bindArr", this.state.bindArr)
            if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {
                return (
                    <tr>
                        <td className="border-bottom" ><a className="text-decoration-none anchor-tag-color cursor-pointer" onClick={() => { this.viewVersion(val.VERSION_NO) }}>{val.VERSION_NO}</a></td> {/*4226,changed the cursor type, Vishwa S*/}
                        <td className="text-center border-bottom">{val.Features}</td>
                        <td className="text-center border-bottom">{val.Bugs}</td>
                        <td className="text-nowrap text-center border-bottom"><a className="mr-3 cursor-pointer"><img src="images/edit-releasenotes-icon.svg" alt="edit" title="Edit" onClick={() => { this.editClick(val) }} /></a><a className="cursor-pointer"><img src="images/delete-releasenotes-icon.svg" alt="delete" title="Delete" onClick={() => { this.showDeletePopUp(val) }} /></a></td>
                    </tr>
                )
            }
        })
    }

    onChangeSearch = (e) => {
        this.setState({ searchValue: e.target.value })
        if (e.target.value == "") {
            this.setDefault()
        }
    }

    setDefault = () => {
        if (this.state.source == "MOB") {
            let count = Math.ceil(this.state.mobArr.length / 10);
            this.setState({ bindArr: this.state.mobArr, pageCount: count, pageNo: 1 })
        }
        else if (this.state.source == "WEB") {
            let count = Math.ceil(this.state.webArr.length / 10);
            this.setState({ bindArr: this.state.webArr, pageCount: count, pageNo: 1 })
        }
    }

    search = () => {
        let editMobileArr = this.state.masterDataArr.filter((e) => e.SOURCE == "MOB");
        let editWebArr = this.state.masterDataArr.filter((e) => e.SOURCE == "WEB");
        let searchedArr = []
        let localBindArr = []
        if (this.state.searchValue.trim() != "") {
            if (this.state.source == "MOB") {
                searchedArr = editMobileArr.filter((x) => x.VERSION_NO.includes(this.state.searchValue) || x.TASK_TITLE.includes(this.state.searchValue));
                searchedArr = searchedArr.filter((v, i, a) => a.findIndex(t => (t.VERSION_NO == v.VERSION_NO)) == i);
                searchedArr.forEach(element => {
                    let obj = this.state.mobArr.filter((x) => x.VERSION_NO == element.VERSION_NO);
                    localBindArr.push(obj[0]);
                });
                let count = Math.ceil(localBindArr.length / 10);
                this.setState({ bindArr: localBindArr, pageCount: count, pageNo: 1 })
            }
            if (this.state.source == "WEB") {
                searchedArr = editWebArr.filter((x) => x.VERSION_NO.includes(this.state.searchValue) || x.TASK_TITLE.includes(this.state.searchValue));
                searchedArr = searchedArr.filter((v, i, a) => a.findIndex(t => (t.VERSION_NO == v.VERSION_NO)) == i);
                searchedArr.forEach(element => {
                    let obj = this.state.webArr.filter((x) => x.VERSION_NO == element.VERSION_NO);
                    localBindArr.push(obj[0]);

                });
                let count = Math.ceil(localBindArr.length / 10);
                this.setState({ bindArr: localBindArr, pageCount: count, pageNo: 1 })
            }

        }
    }


    showDeletePopUp = (val) => {
        deleteVersionNumber = val.VERSION_NO
        $('#deletePopUp').modal('show');
    }


    deleteVersion = (value) => {
        //Bug-5209
        let deleteVersionObj = {
            versionNumber: deleteVersionNumber,
            source: this.state.source,
        }
        if (value == "No") {
            $('#deletePopUp').modal('hide');
        }
        else {
            $('#deletePopUp').modal('hide');
            //loader on
            ReleaseNotesMaintenanceAction.DeleteVersionAction(deleteVersionObj)
        }
    }


    BuildDeleteMessage = () => {
        
        if ((ReleaseNotesMaintenanceStore.deleteResponse) == "True") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "The version have been deleted successfully"
            });
            this.pageLoad();
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "There is an error in deleting the version"
            });
        }
    }


    editClick = (val) => {
        let editMobileEnhancementArr = this.state.masterDataArr.filter((e) => e.TASK_TYPE == "E" & e.SOURCE == "MOB" & e.VERSION_NO == val.VERSION_NO);
        let editMobileBugArr = this.state.masterDataArr.filter((e) => e.TASK_TYPE == "B" & e.SOURCE == "MOB" & e.VERSION_NO == val.VERSION_NO);
        let editWebEnhancementArr = this.state.masterDataArr.filter((e) => e.TASK_TYPE == "E" & e.SOURCE == "WEB" & e.VERSION_NO == val.VERSION_NO);
        let editWebBugArr = this.state.masterDataArr.filter((e) => e.TASK_TYPE == "B" & e.SOURCE == "WEB" & e.VERSION_NO == val.VERSION_NO);
        let mobileVersion = "";
        let webVersion = "";
        let sendEnhancementArr = [];
        let sendBugArr = [];
        

        if (this.state.source == "MOB") {
            this.state.source = "MOB";
            mobileVersion = val.VERSION_NO;
            webVersion = "";
            this.state.submitType = "Update";
            sendEnhancementArr = editMobileEnhancementArr.sort((a, b) => a.TASK_NO - b.TASK_NO);
            sendBugArr = editMobileBugArr.sort((a, b) => a.TASK_NO - b.TASK_NO);
        }
        else if (this.state.source == "WEB") {
            this.state.source = "WEB";
            webVersion = val.VERSION_NO;
            mobileVersion = "";
            this.state.submitType = "Update";
            sendEnhancementArr = editWebEnhancementArr.sort((a, b) => a.TASK_NO - b.TASK_NO);
            sendBugArr = editWebBugArr.sort((a, b) => a.TASK_NO - b.TASK_NO);
        }

        this.props.history.push({
            pathname: "/addversioncomponent",
            state: { source: this.state.source, mobileVersion: mobileVersion, webVersion: webVersion, submitType: this.state.submitType, sendEnhancementArr: sendEnhancementArr, sendBugArr: sendBugArr }
        });
    }





    render() {
        const { t } = this.props
        let bindArr = this.state.bindArr
        //console.error("render BindArr", bindArr)
        return (<React.Fragment>
            <div className="container-fluid container-margin content-section">
                <div className="">
                    <h5 className="page-title">Release Notes Maintenance</h5>


                </div>

                <div>
                    <div className="row">
                        <div className="col-md-12 mt-3">
                            {/*tab starts here*/}
                            <div className="d-md-flex d-block justify-content-between align-items-center border-bottom">
                                <div>
                                    <ul className="nav nav-pills catalog-tabs-mobile catalog-tabs border-0" id="myTab" role="tablist">
                                        <li className="nav-item mx-0">
                                            <a className={this.state.source == "WEB" ? "nav-link active rounded-0 bg-white ml-0 font-medium custom-color1" : "nav-link rounded-0 bg-white font-medium custom-color1 ml-0"} id="web-source-tab" data-toggle="tab" href="#web-source" role="tab" aria-controls="web-source" aria-selected={"true"} onClick={(e) => this.webTabHandleClick(e)}>Web Source</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={this.state.source == "MOB" ? "nav-link active rounded-0 bg-white ml-0 font-medium custom-color1" : "nav-link rounded-0 bg-white font-medium custom-color1 ml-0"} id="mobile-source-tab" data-toggle="tab" href="#mobile-source" role="tab" aria-controls="mobile-source" aria-selected={"False"} onClick={(e) => this.mobTabHandleClick(e)}>Mobile Source</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="d-flex py-3 py-md-0 align-items-center">
                                    <div className="input-group dropdown-search">
                                        <input type="text" className="form-control" placeholder="Search" maxLength="254" aria-label="Text input with dropdown button" onChange={(e) => this.onChangeSearch(e)} style={{ "paddingRight": "48px" }} value={this.state.searchValue} /> {/*4216, 4217, changed the character limit for this field to 256, Divis Kumar R K*/}
                                        <span className={this.state.searchValue != null && this.state.searchValue != "" && this.state.searchValue != " " ? "search-cancel-header cursor-pointer" : "d-none"} style={{ "float": "left" }} onClick={() => this.ClearSearch()}></span>
                                        <span className="dropdown-search-icon cursor-pointer" onClick={this.search} />
                                    </div>
                                    <button className="btn btn-primary action-icon-res custom-btn-primary primary-btn px-3 ml-3" onClick={() => { this.createNewVersion() }}><img className="mr-2" src="images/add-icon.svg" alt="add-icon" />New Version</button>
                                </div>
                            </div>
                            <div className="tab-content Catalog-Items w-100" id="myTabContent">
                                {/*Web Source starts here*/}
                                {this.state.source === "WEB" ? (bindArr != [] && bindArr != "" && bindArr != undefined && bindArr != null ?
                                    <div className="tab-pane py-4 px-0 fade show active" id="web-source" role="tabpanel">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="table-responsive mb-3">
                                                    <table className="table split-delv-table">
                                                        <thead>
                                                            <tr>
                                                                <th className>Version Number<span className="sort-up1 ml-1"><img src="Images/sort2.svg" alt="sort-up" onClick={() => this.sortData("ASC")} /></span><span className="sort-downt ml-1"><img src="Images/sort1.svg" alt="sort-down" onClick={() => this.sortData("DESC")} /></span></th>
                                                                <th className="text-center"># Features</th>
                                                                <th className="text-center"># Bugs</th>
                                                                <th className="text-center">Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {bindArr.length > 0 ? this.bindAllVersionDetails() : null}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div> :
                                    <section className="site-undercontruction container text-center center-panel pt-4">
                                        <div className="img-section">
                                            <img src="images/nosearch.jpg" alt="imagefile" />
                                        </div>
                                        <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                        </p>
                                    </section>) : null}
                                {/*Web Source ends here*/}
                                {/*Mobile Source starts here*/}
                                {this.state.source === "MOB" ? ((bindArr != [] && bindArr != "" && bindArr != undefined && bindArr != null ?
                                    <div className="tab-pane py-4 px-0 show active" id="mobile-source" role="tabpanel">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="table-responsive mb-3">
                                                    <table className="table split-delv-table">
                                                        <thead>
                                                            <tr>
                                                                <th className>Version Number <span className="sort-up1 ml-1">
                                                                    <img src="Images/sort2.svg" alt="sort-up" onClick={(e) => this.sortData("ASC")} /></span><span className="sort-downt ml-1">
                                                                        <img src="Images/sort1.svg" alt="sort-down" onClick={(e) => this.sortData("DESC")} /></span></th>
                                                                <th className="text-center"># Features</th>
                                                                <th className="text-center"># Bugs</th>
                                                                <th className="text-center">Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {bindArr.length > 0 ? this.bindAllVersionDetails() : null}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div> :
                                    <section className="site-undercontruction container text-center center-panel pt-4">
                                        <div className="img-section">
                                            <img src="images/nosearch.jpg" alt="imagefile" />
                                        </div>
                                        <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                        </p>
                                    </section>)) : null}
                                {/*Mobile Source ends here*/}

                            </div>
                            {/*tab ends here*/}
                        </div>
                    </div>
                </div>
                {/*Pagination*/}
                {bindArr != [] && bindArr != "" && bindArr != undefined && bindArr != null ?
                    <div className="col-md-12 mb-5 mb-md-3">
                        {/*<span className="total-records mt-2 d-inline-block">
                        <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{bindArr.length}</span>
                        </span>*/}
                        <div className="d-md-flex d-block justify-content-between align-items-center">
                            <span>
                                <span className="mr-1">{this.state.itemPerPage}</span> <Trans>Versions</Trans> <span> </span> <Trans> In</Trans> <span className="mx-1">1</span> <Trans>Page</Trans> (<span className="mr-1">{bindArr.length}</span> <Trans>Versions In</Trans> <span className="mx-1">{this.state.pageCount}</span> <Trans>{this.state.pageCount == 1 ? "Page)" : "Pages)"}</Trans>
                            </span>
                            <span>
                                {bindArr != [] && bindArr != "" && bindArr != undefined && bindArr != null && this.state.pageCount > 1 ? <ReactPaginate
                                    previousLabel={<span className="right-pagination-arrow" />}
                                    nextLabel={<span className="left-pagination-arrow" />}
                                    previousClassName={'page-item'}
                                    nextClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextLinkClassName={'page-link'}
                                    disabledClassName={'disabled'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={2}
                                    onPageChange={e => this.handlePageClick(e)}
                                    containerClassName={'custom-pagination pagination mt-4 my-md-0 justify-content-center'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                    hrefBuilder={() => '#'}
                                    forcePage={this.state.pageNo - 1}
                                /> : null}</span>
                        </div>

                    </div> : null}

                {/*ViewVersionDetailsPopUp*/}
                <div className="modal" id="ViewVersionDetailsPopUp" >
                    <div className="modal-dialog modal-md modal-dialog-centered sdi-release-modal">
                        <div className="modal-content">
                            {/* Modal body */}
                            <div className="modal-header">
                                <div>
                                    <h5 className="modal-title sdi-release-font-bold" id="exampleModalLongTitle">App Version - {this.state.viewVersionNumber}</h5>
                                </div>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => this.closeViewPopUp(e)}>
                                    <img src="images/close-icon.png" alt="close-icon" />
                                </button>
                            </div>
                            <div className="modal-body sdi-release-modal-body">
                                {/* Features content starts here */}
                                <div className="text-left">
                                    <h2 className="sdi-new-feature">
                                        <span>NEW FEATURES</span>
                                    </h2>
                                    <ul className="sdi-line-gap">
                                        {this.state.viewFeatureArr.length > 0 ? this.bindFeatures() : null}
                                    </ul>
                                </div>
                                {/* Features content ends here */}
                                {/* Bug Fix content starts here */}
                                <div className="text-left">
                                    <h2 className="sdi-new-feature">
                                        <span>BUG FIXES</span>
                                    </h2>
                                    <ul className="sdi-line-gap">
                                        {this.state.viewBugArr.length > 0 ? this.bindBugs() : null}
                                    </ul>
                                </div>
                                {/* Bug Fix content ends here */}
                            </div>
                        </div>
                    </div>
                </div>
                {/*ViewVersionDetailsPopUp*/}
                {/*deletepopup*/}
                {/*Modal Starts here*/}
                <div className="modal fade delete-alternate-approver" role="dialog" id="deletePopUp">
                    <div className="modal-dialog modal-dialog-centered release-notes-custom-delete-width" role="document">
                        <div className="modal-content py-2">
                            {/*Delete Starts here*/}
                            <div className="modal-body pb-0">
                                <div className="row">
                                    <div className="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img className="mb-3" src="images/trash.svg" alt="delete" />
                                        <h5 className="mb-2 font-16 font-bold color-light-black">Delete Confirmation</h5>
                                        <p className="mb-1 font-13 font-regular color-light-black">Are you sure you want to delete this version?</p>
                                    </div>
                                </div>
                            </div>
                            {/*Delete ends here*/}
                            <div className="modal-footer border-0 d-flex justify-content-center">
                                <button className="btn btn-custom-secondary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal" onClick={() => { this.deleteVersion("No") }}>No</button>
                                <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" onClick={() => { this.deleteVersion("Yes") }}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Modal Ends here*/}
            </div>

        </React.Fragment>
        );
    }
} export default withTranslation()(ReleaseNotesMaintenanceComponent);